import axios from 'axios'
const API_URL = process.env.VUE_APP_API_URL;

export function getNotificacoes(ATIVAS, FILTER) {

    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token')
        }
    }

    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/listanotificacoes", {ATIVAS, FILTER}, config).then(resposta => {
            if (resposta.data.Error)
                reject("Erro interno do servidor.");
            else {
                resolve(resposta.data.Rows)
            }
        })
    })
}

export function getNotificacoesDetalhe(NOTCONTADOR, FILTER) {

    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token')
        }
    }

    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/listanotificacoesdetalhe", {NOTCONTADOR, FILTER}, config).then(resposta => {
            if (resposta.data.Error)
                reject("Erro interno do servidor.");
            else {
                resolve(resposta.data.Rows)
            }
        })
    })
}

export function getNotificacoesResumo(NOTCONTADOR, FILTER) {

    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token')
        }
    }

    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/listanotificacoesresumo", {NOTCONTADOR, FILTER}, config).then(resposta => {
            if (resposta.data.Error)
                reject("Erro interno do servidor.");
            else {
                resolve(resposta.data.Rows)
            }
        })
    })
}


